<script>
import { useMessageFormatter } from 'shared/composables/useMessageFormatter';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

import { mapGetters } from 'vuex';
import { useAccount } from 'dashboard/composables/useAccount';
import { useAdmin } from 'dashboard/composables/useAdmin';
import BillingItem from './components/BillingItem.vue';
import { ref } from 'vue';
import { useAlert } from 'dashboard/composables';
import WriteThirdPartyInfo from './components/WriteThirdPartyInfo.vue';
import AIScriptModal from './components/AIScriptModal.vue';
import { useI18n } from 'vue-i18n';
import BillingCard from './components/BillingCard.vue';
import DetailItem from './components/DetailItem.vue';
import ButtonV4 from 'next/button/Button.vue';
import { format } from 'date-fns';
import Button from 'dashboard/components-next/button/Button.vue';
import ScriptItem from './components/ScriptItem.vue';
import ScriptTemplate from './components/ScriptTemplate.vue';

export default {
  components: {
    ScriptItem,
    BillingItem,
    Dialog,
    WriteThirdPartyInfo,
    BillingCard,
    DetailItem,
    ButtonV4,
    AIScriptModal,
    Button,
    ScriptTemplate
  },
  setup() {
    const { viteLivePreviewURL } = window.chatwootConfig || {};
    const { accountId } = useAccount();
    const { formatMessage } = useMessageFormatter();
    const { isAdmin } = useAdmin();
    const confirmDialog = ref(null);
    const confirmTalkDialog = ref(null);
    const showAddPopup = ref(null);
    const showAddTalkPopup = ref(null);
    // 是否加载中
    const loading = ref(false);
    const testConfirmTalkDialog = ref(null);
    const isPublishing = ref(false);

    const { t } = useI18n();
    return {
      accountId,
      formatMessage,
      confirmDialog,
      confirmTalkDialog,
      testConfirmTalkDialog,
      showAddPopup,
      showAddTalkPopup,
      isAdmin,
      t,
      loading,
      isPublishing,
      viteLivePreviewURL
    };
  },
  data() {
    return {
      priceId: window?.chatwootConfig?.viteAppPriceId,
      merchant: null,
      aiAdminBackgroundUrl: window?.chatwootConfig?.viteAppAIAdminBackgroundUrl,
      fileList: [],
    };
  },
  computed: {
    ...mapGetters({
      getAccount: 'accounts/getAccount',
      uiFlags: 'accounts/getUIFlags',
    }),
    isTestMerchant() {
    return this.accountId == window?.chatwootConfig?.testMerchantId;
    },
    currentAccount() {
      return this.getAccount(this.accountId) || {};
    },
    customAttributes() {
      return this.currentAccount.custom_attributes || {};
    },
    hasABillingPlan() {
      return !!this.planName;
    },
    planName() {
      return this.customAttributes.plan_name || '';
    },
    subscribedQuantity() {
      return this.customAttributes.subscribed_quantity || 0;
    },
    subTotalToken() {
      const tokenDesc =
        typeof this?.merchant?.subscription?.usableToken != 'number'
          ? '-'
          : this?.merchant?.subscription?.usableToken >= 1000
            ? `${Math.floor(this?.merchant?.subscription?.usableToken / 1000)}k`
            : this?.merchant?.subscription?.usableToken;
      return tokenDesc;
    },
    subscriptionRenewsOn() {
      console.info('customAttributes', this?.customAttributes);
      if (!this?.customAttributes?.subscription_ends_on) return '';
      const endDate = new Date(this.customAttributes.subscription_ends_on);
      // return date as 12 Jan, 2034
      return format(endDate, 'dd MMM, yyyy');
    },
    isShowPackage() {
      return [
        window?.chatwootConfig?.viteAppBusinessProductIdStarter,
        window?.chatwootConfig?.viteAppBusinessProductIdBusiness,
      ].includes(this?.merchant?.lastestPlanProductId);
    },
  },
  mounted() {
    // this.fetchAccountDetails();
    this.fetchMerchantDetails();
  },
  methods: {
    // async fetchAccountDetails() {
    //   if (!this.hasABillingPlan) {
    //     this.$store.dispatch('accounts/subscription');
    //   }
    // },
    async fetchMerchantDetails() {
      try {
        this.loading = true; // 开始加载
        const merchantData = await this.$store.dispatch('accounts/getMerchant');
        if (merchantData?.code != 200) {
          useAlert(merchantData?.message);
          return;
        }
        this.merchant = merchantData?.data?.item;
      } catch (err) {
        console.info('err: ', err);
      } finally {
        this.loading = false;
      }
    },
    onClickBillingPortal() {
      this.$store.dispatch('accounts/checkout');
    },
    onClickBuyTrafficPacket(priceId) {
      const currentUrl = window.location.href;
      this.$store.dispatch('accounts/checkoutTraffic', {
        priceId: priceId,
        currentUrl: currentUrl,
      });
    },
    onToggleChatWindow() {
      if (window.$chatwoot) {
        window.$chatwoot.toggle();
      }
    },
    onClickToggleMerchantGPTReply() {
      if (this.merchant?.fileUrlList?.length > 0) {
        this.confirmDialog.open();
      } else {
        if (this.merchant?.usableToken > 0) {
          this.openAddTalkPopup();
        } else {
          this.testConfirmTalkDialog.open();
        }
      }
    },
    onClickToAIAdminBackground() {
      window.open(this.aiAdminBackgroundUrl, '_blank');
    },
    onClickConfigurationSpeech() {
      console.info('==--');
    },
    onClickOpenAddThirdPartyInfo() {
      if (this.accountId == window?.chatwootConfig?.testMerchantId) {
        // window.open(`${window?.chatwootConfig?.testRedirectUrl}${this.accountId}`);
        window.location.href = `${window?.chatwootConfig?.testRedirectUrl}${this.accountId}`;
        return;
      }
      this.openAddPopup();
    },
    async onConfirm() {
      const merchantData = await this.$store.dispatch(
        'accounts/toggleMerchantGPT',
        { isEnabled: !this.merchant.gptChatEnabled }
      );
      if (merchantData?.code != 200) {
        if (
          (!Array.isArray(this.merchant?.usedFileUrlList) || this.merchant.usedFileUrlList.length < 1) &&
          merchantData?.message == 'Await Script review complete'
        ) {
          const result = await this.onTalkConfirm();
          if (result) {
            const merchantData = await this.$store.dispatch(
              'accounts/toggleMerchantGPT',
              { isEnabled: !this.merchant.gptChatEnabled }
            );
            if (merchantData?.code != 200) {
              useAlert(merchantData?.message);
              return false;
            }

            useAlert(
              this.t(
                'BILLING_SETTINGS.MANAGE_SUBSCRIPTION.GPT_CHAT_TOGGLE_STATUS'
              )
            );
            this.merchant = merchantData?.data?.item;
            this.confirmDialog.close(); // 关闭 Dialog
          }
        } else {
          useAlert(merchantData?.message);
        }

        return false;
      }
      useAlert(
        this.t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.GPT_CHAT_TOGGLE_STATUS')
      );
      this.merchant = merchantData?.data?.item;
      this.confirmDialog.close(); // 关闭 Dialog
      return true;
    },
    openAddPopup() {
      this.showAddPopup = true;
    },
    hideAddPopup() {
      this.showAddPopup = false;
    },

    openAddTalkPopup() {
      this.showAddTalkPopup = true;
    },
    hideAddTalkPopup() {
      this.showAddTalkPopup = false;
    },

    async onTalkConfirm() {
      // 调用发布接口
      try {
        this.isPublishing = true;
        const merchantData = await this.$store.dispatch(
          'accounts/publishMerchantTalk'
        );
        if (merchantData?.code != 200) {
          useAlert(merchantData?.message);
          return false;
        }
        useAlert(
          this.t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.PUBLISH_TALK_SUCCESS')
        );
        this.merchant = merchantData?.data?.item;
        this.isPublishing = false;
        this.confirmTalkDialog.close(); // 关闭 Dialog
      } catch (error) {
        this.isPublishing = false;
      }

      return true;
    },

    async onTestTalkConfirm() {
      this.$store.dispatch('accounts/checkout');
      this.confirmTalkDialog.close(); // 关闭 Dialog
    },

    async handleUpdateMerchant(shopData) {
      const merchantData = await this.$store.dispatch(
        'accounts/updateMerchantShop',
        { shopData }
      );
      if (merchantData?.code && merchantData?.code != 200) {
        useAlert(
          merchantData?.message ||
            this.t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.SAVE_GPT_SHOP_FAILED')
        );
        return;
      }
      this.merchant = merchantData?.data?.item;
      return merchantData?.data?.item;
    },
    async handleUpdateMerchantTalk(params) {
      const merchantData = await this.$store.dispatch(
        'accounts/updateMerchantScriptRecord',
        params
      );
      if (merchantData?.code && merchantData?.code != 200) {
        useAlert(
          merchantData?.message ||
            this.t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.SAVE_GPT_SHOP_FAILED')
        );
        return;
      }
      this.merchant = merchantData?.data?.item;
      return merchantData?.data?.item;
    },
    onClickNavigateToNewInbox() {
      if (this.isAdmin) {
        this.$router.push({ name: 'billing_settings_prompt_list' });
      }
    },
    areFileURLListsEqualIgnoreOrder(existingList, incomingList) {
      if (existingList.length !== incomingList.length) {
        return false;
      }

      const countMap = new Map();

      for (const item of existingList) {
        countMap.set(item, (countMap.get(item) || 0) + 1);
      }

      for (const item of incomingList) {
        if (!countMap.has(item)) {
          return false;
        }
        countMap.set(item, countMap.get(item) - 1);
        if (countMap.get(item) === 0) {
          countMap.delete(item);
        }
      }

      return countMap.size === 0;
    },

    talkReviewStatusTitle() {
      if (!Array.isArray(this?.merchant?.fileUrlList) || this?.merchant?.fileUrlList.length < 1) {
        return this.$t(
          'BILLING_SETTINGS.MANAGE_SUBSCRIPTION.TALK_REVIEW_STATUS_PREV'
        );
      }
      if (this?.merchant?.errorDesc) {
        return this.$t(
          'BILLING_SETTINGS.MANAGE_SUBSCRIPTION.TALK_REVIEW_STATUS_FAILURE'
        );
      }
      let isCompare = this.areFileURLListsEqualIgnoreOrder(
        this?.merchant?.fileUrlList || [],
        this?.merchant?.usedFileUrlList || []
      );
      if (this?.merchant?.reviewStatus === 'new') {
        return this.$t(
          'BILLING_SETTINGS.MANAGE_SUBSCRIPTION.TALK_REVIEW_STATUS_NEW'
        );
      }
      if (this?.merchant?.reviewStatus === 'processing') {
        return this.$t(
          'BILLING_SETTINGS.MANAGE_SUBSCRIPTION.TALK_REVIEW_STATUS_PROCESSING'
        );
      }
      if (isCompare && this?.merchant?.reviewStatus === 'completed') {
        return this.$t(
          'BILLING_SETTINGS.MANAGE_SUBSCRIPTION.TALK_REVIEW_STATUS_COMPLETED'
        );
      }

      if (!isCompare && this?.merchant?.reviewStatus === 'completed') {
        return this.$t(
          'BILLING_SETTINGS.MANAGE_SUBSCRIPTION.TALK_REVIEW_STATUS_NEW'
        );
      }
      return '';
    },

    talkReviewStatusBtnLabel() {
      if (!Array.isArray(this.merchant?.fileUrlList) || this?.merchant?.fileUrlList?.length < 1) {
        return this.$t(
          'BILLING_SETTINGS.MANAGE_SUBSCRIPTION.TALK_REVIEW_STATUS_NEW_BTN_NON'
        );
      }
      if (this?.merchant?.reviewStatus === 'new') {
        return this.$t(
          'BILLING_SETTINGS.MANAGE_SUBSCRIPTION.TALK_REVIEW_STATUS_TITLE'
        );
      }
      if (this?.merchant?.reviewStatus === 'processing') {
        return this.$t(
          'BILLING_SETTINGS.MANAGE_SUBSCRIPTION.TALK_REVIEW_STATUS_PROCESSING_BTN'
        );
      }
      if (this?.merchant?.reviewStatus === 'completed') {
        return this.$t(
          'BILLING_SETTINGS.MANAGE_SUBSCRIPTION.TALK_REVIEW_STATUS_TITLE'
        );
      }
      return '';
    },
    getDocsUrl(fileUrl) {
      if (!fileUrl) {
        return this.$t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.SCRIPT_EMPTY');
      }
      const decodedUrl = decodeURIComponent(fileUrl);
      const fileName = decodedUrl.substring(decodedUrl.lastIndexOf('/') + 1);
      return fileName;
    },
    async publishTalk() {
      if (
        this?.merchant?.reviewStatus == 'processing' &&
        this?.merchant?.approvedFileUrlList?.length > 0
      ) {
        this.confirmTalkDialog.open();
      } else {
        if (this.merchant?.usableToken > 0 || this.merchant?.usedFileUrlList?.length > 0) {
          this.openAddTalkPopup();
        } else {
          this.testConfirmTalkDialog.open();
        }
      }
    },
    onClickTest() {
      if (this.merchant?.usableToken < 1) {
        this.testConfirmTalkDialog.open();
        return true;
      }

      return false;
    },
    onCancelClick() {
      this.confirmTalkDialog.close();
    },
    onReuploadClick() {
      this.confirmTalkDialog.close();
      this.openAddTalkPopup();
    },
  },
};
</script>

<template>
  <div class="flex-1 p-6 overflow-auto dark:bg-slate-900">
    <woot-loading-state v-if="loading" />
    <div v-else-if="!hasABillingPlan">
      <p>{{ $t('BILLING_SETTINGS.NO_BILLING_USER') }}</p>
    </div>
    <div v-else class="w-full">
      <BillingItem
        image-url="/brand-assets/toggle-line"
        :title="
          $t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.GPT_CHAT_STATUS', {
            statusDesc: this.merchant?.gptChatEnabled
              ? $t(
                  'BILLING_SETTINGS.MANAGE_SUBSCRIPTION.GPT_CHAT_STATUS_ENABLE_DESC'
                )
              : $t(
                  'BILLING_SETTINGS.MANAGE_SUBSCRIPTION.GPT_CHAT_STATUS_CLOSE_DESC'
                ),
          })
        "
        :description="
          typeof this?.merchant?.usableToken == 'number'
            ? $t(
                'BILLING_SETTINGS.MANAGE_SUBSCRIPTION.TOTAL_AVAILABLE_TOKENS',
                {
                  totalToken: `${this.merchant?.usableToken >= 1000 ? `${Math.floor(this.merchant?.usableToken / 1000)}k` : this.merchant?.usableToken}`,
                }
              )
            : '-'
        "
        :button-label="
          this.merchant?.gptChatEnabled
            ? $t(
                'BILLING_SETTINGS.MANAGE_SUBSCRIPTION.CLOSE_GPT_CHAT_BUTTON_TXT'
              )
            : $t(
                'BILLING_SETTINGS.MANAGE_SUBSCRIPTION.ENABLE_GPT_CHAT_BUTTON_TXT'
              )
        "
        button-icon="send-clock"
        @open="onClickToggleMerchantGPTReply"
      />
      <BillingCard
        v-if="!isTestMerchant"
        :title="$t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.TITLE')"
        :description="$t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.DESCRIPTION')"
      >
        <template #action>
          <woot-image-button
            :classNames="'custom-button'"
            variant="smooth"
            icon="/brand-assets/bill-line"
            @click="onClickBillingPortal"
          >
            {{ $t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.BUTTON_TXT') }}
          </woot-image-button>
        </template>
        <div
          v-if="planName || subscribedQuantity || subscriptionRenewsOn"
          class="grid lg:grid-cols-4 sm:grid-cols-3 grid-cols-1 gap-2 divide-x divide-n-weak"
        >
          <DetailItem
            :label="$t('BILLING_SETTINGS.CURRENT_PLAN.TITLE')"
            :value="planName"
          />
          <DetailItem
            v-if="subscribedQuantity"
            :label="$t('BILLING_SETTINGS.CURRENT_PLAN.QUANTITY_NUMBER')"
            :value="subTotalToken"
          />
          <DetailItem
            v-if="isShowPackage"
            :label="$t('BILLING_SETTINGS.CURRENT_PLAN.RENEWS_ON')"
            :value="subscriptionRenewsOn"
          />
        </div>
      </BillingCard>
      <BillingItem
        v-if="isShowPackage"
        image-url="/brand-assets/bank-card-line"
        :title="$t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.TRAFFIC_PACKAGE1')"
        :description="
          $t(
            'BILLING_SETTINGS.MANAGE_SUBSCRIPTION.TRAFFIC_PACKAGE1_DESCRIPTION'
          )
        "
        :button-label="
          $t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.TRAFFIC_PACKAGE_BUTTON_TXT')
        "
        button-icon=""
        :price-id="priceId"
        @open="onClickBuyTrafficPacket"
      />

      <ScriptItem
        image-url="/brand-assets/file-check-line"
        :title="
          $t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.TALK_REVIEW_STATUS', {
            reviewStatusDesc: talkReviewStatusTitle(),
          })
        "
        :button-label="talkReviewStatusBtnLabel()"
        :merchant="merchant"
        :error-desc="merchant?.errorDesc"
        button-icon=""
        :is-dot="true"
        @open="publishTalk"
      />

      <BillingItem
        v-if="!isTestMerchant"
        image-url="/brand-assets/store-line"
        :title="
          $t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.GPT_THIRD_PARTY_INFO_TITLE')
        "
        :description="
          $t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.GPT_THIRD_PARTY_INFO_DESC')
        "
        :button-label="$t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.GPT_SET_UP')"
        button-icon=""
        @open="onClickOpenAddThirdPartyInfo"
      />
      <BillingCard
        v-else
        :title="
          $t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.GPT_THIRD_PARTY_INFO_TITLE')
        "
        :description="
          $t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.GPT_THIRD_PARTY_INFO_DESC')
        "
      >
        <template #action>
          <woot-image-button
            :classNames="'custom-button'"
            variant="smooth"
            icon="/brand-assets/store-line"
            @click="onClickOpenAddThirdPartyInfo"
          >
            {{
              this.merchant?.shops?.[0]?.shopName
                ? $t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.GPT_RE_SET_UP')
                : $t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.GPT_SET_UP')
            }}
          </woot-image-button>
        </template>
        <div
          class="grid lg:grid-cols-4 sm:grid-cols-3 grid-cols-1 gap-2 divide-x divide-n-weak"
        >
          <DetailItem
            :label="
              $t(
                'BILLING_SETTINGS.MANAGE_SUBSCRIPTION.GPT_THIRD_PARTY_SHOPIFY_SHOP_NAME_LABEL'
              )
            "
            :value="
              this.merchant?.shops?.[0]?.shopName ||
              $t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.SCRIPT_EMPTY')
            "
          />
          <DetailItem
            v-if="subscribedQuantity"
            :label="
              $t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.GPT_SET_UP_STATUS')
            "
            :value="
              this.merchant?.shops?.[0]?.shopName
                ? $t(
                    'BILLING_SETTINGS.MANAGE_SUBSCRIPTION.GPT_SET_UP_STATUS_DESC'
                  )
                : $t(
                    'BILLING_SETTINGS.MANAGE_SUBSCRIPTION.GPT_NON_SET_UP_STATUS_DESC'
                  )
            "
          />
        </div>
      </BillingCard>
      <!-- <BillingItem
        :title="$t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.GPT_CHAT_PROMPT_TITLE')"
        :description="$t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.GPT_CHAT_PROMPT_DESC')"
        :button-label="$t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.GPT_CHAT_PROMPT_LABEL')"
        button-icon=""
        @open="onClickNavigateToNewInbox"
      /> -->
      <!-- <BillingItem
        :title="$t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.TITLE')"
        :description="$t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.DESCRIPTION')"
        :button-label="$t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.BUTTON_TXT')"
        @open="onClickBillingPortal"
      /> -->
      <!-- <BillingItem
        :title="$t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.GPT_ADMIN_BACKGROUND')"
        :description="$t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.GPT_ADMIN_BACKGROUND_DESC')"
        button-label="OPEN"
        button-icon=""
        @open="onClickToAIAdminBackground"
      /> -->
      <ScriptItem
        :on-open="onClickTest"
        :test-chat="true"
        :is-test="this.merchant?.usableToken < 1"
        :gptChatEnabled="this.merchant?.approvedFileUrlList?.length > 0"
        :title="$t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.TEST_PROMPT_TITLE')"
        :button-label="
          $t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.TEST_BUTTON_TXT')
        "
        :merchant="merchant"
        button-icon="chat-multiple"
      />

      <BillingItem
        :title="$t('BILLING_SETTINGS.CHAT_WITH_US.TITLE')"
        :description="$t('BILLING_SETTINGS.CHAT_WITH_US.DESCRIPTION')"
        :button-label="$t('BILLING_SETTINGS.CHAT_WITH_US.BUTTON_TXT')"
        button-icon="chat-multiple"
        image-url="/brand-assets/help"
        @open="onToggleChatWindow"
      />
    </div>
    <Dialog
      ref="confirmDialog"
      type="alert"
      :title="
        !this.merchant?.gptChatEnabled
          ? $t(
              'BILLING_SETTINGS.MANAGE_SUBSCRIPTION.ENABLE_GPT_CHAT_BUTTON_TXT'
            )
          : $t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.CLOSE_GPT_CHAT_BUTTON_TXT')
      "
      :description="
        this.merchant?.gptChatEnabled
          ? $t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.GPT_CHAT_STATUS_CLOSE_TIP')
          : $t(
              'BILLING_SETTINGS.MANAGE_SUBSCRIPTION.GPT_CHAT_STATUS_ENABLE_TIP'
            )
      "
      :confirm-button-label="
        $t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.CONFIRM_TEXT')
      "
      :cancel-button-label="
        $t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.CANCEL_TEXT')
      "
      @confirm="onConfirm"
    />

    <Dialog
      ref="confirmTalkDialog"
      type="alert"
      :title="$t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.PUBLISH_TALK_TITLE')"
      :description="
        $t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.PUBLISH_TALK_DESC', {
          shopFileUrl: this.getDocsUrl(this?.merchant?.approvedFileUrl),
          usedFileUrl: this.getDocsUrl(this?.merchant?.usedFileUrl),
        })
      "
      :confirm-button-label="
        $t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.CONFIRM_TEXT')
      "
      :cancel-button-label="
        $t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.CANCEL_TEXT')
      "
    >
      <!-- 自定义 description -->
      <template #description>
        <div class="text-sm text-n-slate-11">
          <p>{{ $t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.PUBLISH_TALK_DESC1') }}</p>
          <div
            v-for="(fileUrl, index) in (this?.merchant?.approvedFileUrlList || [])"
            :key="index"
          >
            <a
              :href="(viteLivePreviewURL || '') + fileUrl"
              class="highlight text-blue-700 hover:text-blue-900 hover:underline font-medium truncate"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ getDocsUrl(fileUrl) }}
            </a>
          </div>
        </div>
      </template>
      <template #footer>
        <div class="flex items-center justify-between w-full gap-3">
          <!-- 重新上传按钮 -->
          <Button
            variant="faded"
            color="slate"
            :label="$t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.REUPLOAD_TEXT')"
            class="w-full"
            @click="onReuploadClick"
          />

          <!-- 发布按钮 -->
          <Button
            color="ruby"
            :label="$t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.CONFIRM_TEXT')"
            class="w-full"
            :is-loading="isPublishing"
            @click="onTalkConfirm"
          />
        </div>
      </template>
    </Dialog>


    <Dialog
      ref="testConfirmTalkDialog"
      type="alert"
      :title="$t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.GO_SUB_TITLE')"
      :description="$t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.GO_SUB_DESC')"
      :confirm-button-label="
        $t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.GO_SUB_TEXT')
      "
      :cancel-button-label="
        $t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.CANCEL_TEXT')
      "
      @confirm="onTestTalkConfirm"
    />

    <woot-modal v-model:show="showAddPopup" :on-close="hideAddPopup">
      <WriteThirdPartyInfo
        @close="hideAddPopup"
        :merchant="this.merchant"
        :submitData="handleUpdateMerchant"
      />
    </woot-modal>

    <woot-modal v-model:show="showAddTalkPopup" :on-close="hideAddTalkPopup">
      <AIScriptModal
        @close="hideAddTalkPopup"
        :merchant="this.merchant"
        :submitData="handleUpdateMerchantTalk"
      />
    </woot-modal>
  </div>
</template>

<style lang="scss">
.highlight {
  color: #409EFF; /* 常见的蓝色高亮 */
  text-decoration: underline; /* 下划线 */
  cursor: pointer; /* 鼠标变为手指 */
}

.custom-button {
  min-width: 140px;
  display: flex;
  justify-content: center;
}
.manage-subscription {
  @apply bg-white dark:bg-slate-800 flex justify-between mb-2 py-6 px-4 items-center rounded-md border border-solid border-slate-75 dark:border-slate-700;
}

.current-plan--details {
  @apply border-b border-solid border-slate-75 dark:border-slate-800 mb-4 pb-4;

  h6 {
    @apply text-slate-800 dark:text-slate-100;
  }

  p {
    @apply text-slate-600 dark:text-slate-200;
  }
}

.manage-subscription {
  .manage-subscription--description {
    @apply mb-0 text-slate-600 dark:text-slate-200;
    white-space: pre-line;
  }

  h6 {
    @apply text-slate-800 dark:text-slate-100;
  }
}
</style>
